var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag is-primary is-light"},[_vm._v(" You have "+_vm._s(_vm.amountAffondollar === null ? '---' : _vm.amountAffondollar)+" affondollars. ")])}
var staticRenderFns = []

export { render, staticRenderFns }